function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { VF } from '../../../models/ParamValidator';
import React from 'react';

/**
 * Default cell renderer for DataGrid
 * 
 * @param {Object} props
 * @param {*} props.value - The value to display in the cell
 * @param {boolean} props.isEditable - Whether the cell is editable (affects cursor style and appearance)
 * @param {number} props.tabIndex - Tab index for keyboard navigation
 * @param {Object} props.style - Optional additional styles
 * @returns {JSX.Element}
 */
export function DefaultCell(_ref) {
  let {
    header,
    value,
    isEditable = false,
    tabIndex,
    style = {}
  } = _ref;
  const trimmedValue = value !== null && value !== void 0 && value.trim ? value.trim().toLowerCase() : value;
  const valueIsCheckboxTick = ((trimmedValue === null || trimmedValue === void 0 ? void 0 : trimmedValue.length) || 0) > 0 && trimmedValue !== 'false' && header.cellType === 'checkbox';
  let displayValue = value;

  // Need to convert in case its a string '123'. We use Number() instead of parseFloat, because
  // parseFloat reads any number in text. '123 asd' would become 123, which is incorrect.
  const possiblyNumericValue = Number(value);
  if (header.cellType === 'number' && VF.isNumber(possiblyNumericValue)) {
    displayValue = possiblyNumericValue.toLocaleString('en-GB', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  } else if (header.cellType === 'percentage' && VF.isNumber(possiblyNumericValue)) {
    var _header$decimalScale;
    displayValue = "".concat(possiblyNumericValue.toFixed((_header$decimalScale = header.decimalScale) !== null && _header$decimalScale !== void 0 ? _header$decimalScale : 1), "%");
  }
  const justifyContent = header.cellType === 'percentage' ? 'center' : header.cellType === 'number' ? 'flex-end' : 'flex-start';
  return /*#__PURE__*/React.createElement("div", {
    className: "DataGridTable-DefaultCell",
    style: _objectSpread({
      padding: '4px 8px',
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent,
      cursor: isEditable ? 'pointer' : 'default',
      backgroundColor: isEditable ? 'transparent' : '#f5f5f5',
      color: valueIsCheckboxTick ? 'var(--color-primary)' : 'inherit',
      fontSize: valueIsCheckboxTick ? '24px' : 'inherit'
    }, style),
    tabIndex: tabIndex
  }, displayValue);
}